import React from 'react';
import { Alert } from 'antd';

export default class PaymentError extends React.Component {
	componentDidMount() {
		if (window.location.href.indexOf('clearCart') !== -1) {
			localStorage.removeItem('fieldProgramCart');
		}
	}
	render() {
		return (
			<Alert showIcon
				icon="frown-o"
				type="warning"
				message="Uh oh"
				description={
					<span>
						Your payment has failed but don't worry, you are still registered for your programs.
						<br /><br />
						For questions about reconciling your balance please reach out to Field programs at <a href="mailto:field@isevoyages.org">field@isevoyages.org</a> as soon as possible.
				 	</span>
				 } />
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/PaymentFailed/index.jsx